<template>
  <div class="skel-card">
    <div class="skel-card-main">
      <div class="skel-card-left">
        <SkeletonBlock width="70%" height="16px" />
        <SkeletonBlock width="50%" height="11px" />
        <SkeletonBlock width="40%" height="11px" />
        <SkeletonBlock width="60%" height="11px" />
        <SkeletonBlock width="90px" height="90px" radius="50%" />
      </div>
      <div class="skel-card-right">
        <SkeletonBlock width="100%" height="100%" radius="10px" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SkeletonBlock from './SkeletonBlock.vue'

export default defineComponent({
  name: 'SkeletonCard',
  components: { SkeletonBlock }
})
</script>

<style scoped lang="scss">
.skel-card {
  border: 1px solid rgba(31, 30, 26, 0.12);
  border-radius: 12px;
  overflow: hidden;
  background: var(--card, #fff);
}

.skel-card-main {
  width: 100%;
  aspect-ratio: 4 / 3;
  display: grid;
  grid-template-columns: 3fr 2fr;
}

.skel-card-left {
  padding: 14px;
  display: grid;
  align-content: start;
  gap: 10px;
}

.skel-card-right {
  padding: 14px 14px 14px 0;
}
</style>
